import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Link} from 'react-router-dom'
import {Grid, Row, Col} from 'react-bootstrap'
import ArticlesList from './articles-list'
import ArticleSearch from './articles-search'
import {getArticles} from '../../../../../actions/news'
import ArrowButton from '../../../../common/button-arrow'
import PageTitle from '../../../../common/page-title/index'

import './styles.css'

class Articles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title:    '',
      dateFrom: '',
      dateTo:   '',
      status:   ''
    };
  }

  componentWillMount() {
    this.props.dispatch(actions.load('deep.admin_news.article', {
      news_category_id: 0,
      status: '',
      linked_article_ids: [],
      permission_ids: {}
    }));
    this.props.dispatch(getArticles());
  }

  handleInputChange = (e) => {
    this.setState({title: e.target.value});
  };

  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({dateFrom: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateFrom: ''});
    }
  };

  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({dateTo: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateTo: ''});
    }
  };

  handleStatusChange = (e) => {
    this.setState({status: e.target.value});
  };

  handleSearch = () => {
    const {title, dateFrom, dateTo, status} = this.state;
    this.props.dispatch(getArticles(title, dateFrom, dateTo, status));
  };

  handleClear = () => {
    this.setState({
      title:    '',
      dateFrom: '',
      dateTo:   '',
      status:   ''
    }, this.handleSearch);
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="news">
        <PageTitle>Articles</PageTitle>
        <Link to="/admin/news/articles/new">
          <ArrowButton color="red"
                       className="add-article"
                       submit={false}
                       arrow={false}
                       permissions={{
                         action: 'create',
                         subjectClass: 'Article'
                       }}>Add article</ArrowButton>
        </Link>

        <Row>
          <Col md={12}>
            <ArticleSearch statusList={this.props.statusList}
                           searchValue={this.state.title}
                           statusOrderValue={this.state.status}
                           dateFromValue={this.state.dateFrom}
                           dateToValue={this.state.dateTo}
                           onInputChange={this.handleInputChange}
                           onDateFromChange={this.handleDateFromChange}
                           onDateToChange={this.handleDateToChange}
                           onStatusOrderChange={this.handleStatusChange}
                           onSearch={this.handleSearch}
                           onClear={this.handleClear}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ArticlesList articles={this.props.articles}
                          fetching={this.props.fetching}
                          fetched={this.props.fetched}
            />
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    articles:   state.news.articles.articles,
    statusList: state.news.articles.statusList,
    fetching:   state.news.articles.fetching,
    fetched:    state.news.articles.fetched
  };
};

export default connect(mapStateToProps)(Articles);


// WEBPACK FOOTER //
// ./src/components/admin/news/articles/list/index.jsx